/* Elysian Subscriptions page (2026-09-27). Loaded by sections/elysian-plans.liquid only.
   1. Per-coffee prices: picking a coffee swaps the size tiles' prices and the "Best value" pill (values rendered by Liquid in data attributes).
   2. Savings pill lift: marks a size pick on its tile row (data-ely-chosen), so only a pick lifts the pill, never the preselected tile.
   3. Anchored modules (the gift link lands on #gift-subscription): the home hero's slow pan (assets/elysian-hero-v6.js, same easing,
      duration and landing), both for in-page links and on arrival from another page. On arrival the module's inline script has taken
      its id off before the browser could jump, so the page opens at the top and pans down; the id comes back when the pan ends.
      Reduced motion: the native instant jump (the inline script leaves the id alone). Without JS the plain #anchor still works. */
(function () {
  /* 1 and 2 */
  function bind(sub) {
    if (sub.dataset.elyBound) return;
    sub.dataset.elyBound = '1';
    var tiles = sub.querySelector('.ely-size-tiles');
    sub.querySelectorAll('[data-ely-sub-size]').forEach(function (r) {
      r.addEventListener('change', function () { if (tiles && !tiles.hasAttribute('data-ely-chosen')) tiles.setAttribute('data-ely-chosen', ''); });
    });
    if (!sub.hasAttribute('data-ely-sub-prices')) return;
    var apply = function () {
      var c = sub.querySelector('[data-ely-sub-coffee]:checked');
      var i = c ? (parseInt(c.value, 10) || 1) - 1 : 0;
      sub.querySelectorAll('[data-ely-sub-price]').forEach(function (el) {
        var v = el.getAttribute('data-ely-sub-price').split('|')[i];
        if (v !== undefined && el.textContent !== v) el.textContent = v;
      });
      sub.querySelectorAll('[data-ely-sub-save]').forEach(function (el) {
        var v = (el.getAttribute('data-ely-sub-save').split('|')[i] || '').trim();
        if (v) { el.textContent = v; el.hidden = false; } else { el.hidden = true; }
      });
    };
    sub.querySelectorAll('[data-ely-sub-coffee]').forEach(function (r) { r.addEventListener('change', apply); });
    apply();
  }

  /* 3 */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pinnedHeaderHeight = function () {
    var h = 0;
    document.querySelectorAll('.ely-header, sticky-header, .section-header').forEach(function (el) {
      var pos = getComputedStyle(el).position;
      var r = el.getBoundingClientRect();
      if ((pos === 'sticky' || pos === 'fixed') && r.top <= 1 && r.bottom > 0) h = Math.max(h, r.bottom);
    });
    return h;
  };
  var easeInOutCubic = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  /* lands the module's heading 32 below any pinned header (the hero's landing); the module's own top edge sits just above it */
  function pan(target, hash, done) {
    var anchor = target.querySelector('h1, h2, h3') || target;
    var destination = function () {
      var y = window.pageYOffset + target.getBoundingClientRect().top - pinnedHeaderHeight() - 32;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      return Math.max(0, Math.min(y, max));
    };
    var finish = function () {
      if (done) done();
      if (!anchor.hasAttribute('tabindex')) anchor.setAttribute('tabindex', '-1');
      try { anchor.focus({ preventScroll: true }); } catch (err) { /* very old engines: skip focus rather than jump */ }
      if (hash && history.replaceState) history.replaceState(null, '', hash);
    };
    var root = document.documentElement;
    var prevBehavior = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    var restore = function () { root.style.scrollBehavior = prevBehavior; };
    if (reduceMotion) { window.scrollTo(0, destination()); restore(); finish(); return; }
    var start = window.pageYOffset;
    var duration = Math.min(1800, Math.max(1400, 1100 + Math.abs(destination() - start) * 0.5));
    var t0 = null;
    var cancelled = false;
    var cancel = function () { cancelled = true; };
    var events = ['wheel', 'touchstart', 'keydown', 'mousedown'];
    events.forEach(function (ev) { window.addEventListener(ev, cancel, { passive: true, once: true }); });
    var cleanup = function () { events.forEach(function (ev) { window.removeEventListener(ev, cancel); }); };
    var step = function (now) {
      if (cancelled) { cleanup(); restore(); if (done) done(); return; }
      if (t0 === null) t0 = now;
      var t = Math.min((now - t0) / duration, 1);
      /* the destination is re-read every frame, so fonts or images settling mid-pan cannot leave it short */
      window.scrollTo(0, start + (destination() - start) * easeInOutCubic(t));
      if (t < 1) requestAnimationFrame(step);
      else { cleanup(); restore(); finish(); }
    };
    requestAnimationFrame(step);
  }

  function init() {
    document.querySelectorAll('[data-ely-sub]').forEach(bind);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);

  /* in-page links to a module anchor */
  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('a[href*="#"]') : null;
    if (!link || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var url;
    try { url = new URL(link.href, location.href); } catch (err) { return; }
    if (url.pathname !== location.pathname || url.hash.length < 2) return;
    var target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (!target || !target.hasAttribute('data-ely-sub')) return;
    e.preventDefault();
    pan(target, url.hash);
  });

  /* arrival: the inline script moved the id to data-ely-pan-to; open at the top, then pan */
  function arrive() {
    var target = document.querySelector('[data-ely-pan-to]');
    if (!target) return;
    var id = target.getAttribute('data-ely-pan-to');
    var put = function () { if (!target.id) target.id = id; target.removeAttribute('data-ely-pan-to'); };
    window.scrollTo(0, 0);
    setTimeout(function () { pan(target, null, put); }, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrive); else arrive();
})();
